export default __webpack_public_path__ + "static/media/Certificado Basc -2023.8475943f.jpg";